import { render, staticRenderFns } from "./MapeamentoCampos.vue?vue&type=template&id=754df9ef&scoped=true"
import script from "./MapeamentoCampos.vue?vue&type=script&lang=js"
export * from "./MapeamentoCampos.vue?vue&type=script&lang=js"
import style0 from "./MapeamentoCampos.vue?vue&type=style&index=0&id=754df9ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754df9ef",
  null
  
)

export default component.exports